<ng-template #progressInfoTemplate>
  <span class="ant-progress-text" *ngIf="dwShowInfo">
    <ng-container *ngIf="(dwStatus=='exception')||(dwStatus=='success')&&(!isFormatSet); else formatTemplate">
      <i class="anticon" [ngClass]="iconClassMap"></i>
    </ng-container>
    <ng-template #formatTemplate>
      {{ dwFormat(dwPercent) }}
    </ng-template>
  </span>
</ng-template>
<div [ngClass]="'ant-progress ant-progress-status-'+dwStatus"
  [class.ant-progress-line]="dwType=='line'"
  [class.ant-progress-small]="dwSize=='small'"
  [class.ant-progress-show-info]="dwShowInfo"
  [class.ant-progress-circle]="isCirCleStyle">
  <div *ngIf="dwType=='line'">
    <div class="ant-progress-outer">
      <div class="ant-progress-inner">
        <div class="ant-progress-bg" [style.width.%]="dwPercent" [style.height.px]="dwStrokeWidth"></div>
        <div class="ant-progress-success-bg" [style.width.%]="dwSuccessPercent" [style.height.px]="dwStrokeWidth"></div>
      </div>
    </div>
    <ng-template [ngTemplateOutlet]="progressInfoTemplate"></ng-template>
  </div>
  <div
    [style.width.px]="this.dwWidth"
    [style.height.px]="this.dwWidth"
    [style.fontSize.px]="this.dwWidth*0.15+6"
    class="ant-progress-inner"
    *ngIf="isCirCleStyle">
    <svg class="ant-progress-circle " viewBox="0 0 100 100">
      <path
        class="ant-progress-circle-trail"
        stroke="#f3f3f3"
        fill-opacity="0"
        [attr.stroke-width]="dwStrokeWidth"
        [ngStyle]="trailPathStyle"
        [attr.d]="pathString">
      </path>
      <path
        class="ant-progress-circle-path"
        [attr.d]="pathString"
        stroke-linecap="round"
        fill-opacity="0"
        [attr.stroke]="statusColorMap[dwStatus]"
        [attr.stroke-width]="dwPercent?dwStrokeWidth:0"
        [ngStyle]="strokePathStyle">
      </path>
    </svg>
    <ng-template [ngTemplateOutlet]="progressInfoTemplate"></ng-template>
  </div>
</div>